import BangKeo from "../BangKeo";

const KbvBangKeoKetQua = () => {
  return <BangKeo type="ketqua" />
};

export default KbvBangKeoKetQua;